"use client";
import React, { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import CommonButton from "./CommonButton";
import contact from "../../public/assets/images/pricing/contact.png";
import Image from "next/image";
import Link from "next/link";
import { event } from "@/lib/analytics";
import PricingDetailsForm from "@/components/PricingDetailsForm";
import { useRouter } from "next/navigation";
import { verifyToken } from "@/services/pricing";
const ExitPageModal = ({ show, onHide, onCostEstimate }) => {
  const [modalShow, setModalShow] = useState(false);
  const router = useRouter();
  return (
    <>
      <Modal
        backdrop="static"
        keyboard={false}
        show={show}
        onHide={onHide}
        centered
        size="lg"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title>
            Too Expensive? <span>Let’s Talk Before You Decide.</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <Row className="gy-4">
            <Col lg={6} md={12} className="align-self-center d-none d-lg-block">
              <div className="image-background-exit">
                <Image
                  src={contact}
                  alt={"Let’s Talk Before You Decide"}
                  height={300}
                  width={300}
                  className="img-fluid mx-auto d-block"
                />
              </div>
            </Col>
            <Col lg={6} md={12} className="align-self-center">
              <p className="p-0 mb-2">
                You might be overestimating cost — we offer:
              </p>
              <ul>
                <li>
                  <strong>Tailored teams under $5K/month</strong>
                </li>
                <li>
                  <strong>Zero hiring headaches</strong>
                </li>
                <li>
                  <strong>Weekly reporting & full transparency</strong>
                </li>
                <li>
                  <strong>No long-term lock-in</strong>
                </li>
                <li>
                  <strong className="primary-color">
                    And even your budget flexible pricing
                  </strong>
                </li>
              </ul>
              <p>Let’s explore what works for you.</p>
              <div className="d-flex justify-content-center justify-content-lg-start gap-3 mt-4 exit-buttons-footer">
                <CommonButton
                  label="Cost Estimate"
                  className="black-border"
                  variant="outline"
                  onClick={async () => {
                    try {
                      const isAuthDetails =
                        !!localStorage.getItem("authDetails");
                      if (!isAuthDetails) {
                        setModalShow(true);
                        return;
                      }
                      const isAuthenticated = await verifyToken();
                      if (isAuthenticated) {
                        router.replace("/custom-pricing");
                        onHide();
                      } else {
                        onHide();
                        setModalShow(true);
                      }
                    } catch (error) {
                      onHide();
                      setModalShow(true);
                    }
                  }}
                />
                <Link
                  href={"https://calendly.com/greet_at_neoverce/30min"}
                  role="button"
                  target="_blank"
                  aria-label={`Book Strategy Call`}
                >
                  <CommonButton
                    label="Book Strategy Call"
                    onClick={() =>
                      event({
                        action: "book call",
                        params: { page: "Exit modal" },
                      })
                    }
                  />
                </Link>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <PricingDetailsForm modalShow={modalShow} setModalShow={setModalShow} />
    </>
  );
};

export default ExitPageModal;
